//* React
import React from 'react';

//* mui
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

//* project
import { customizationTabOutletMinHeight } from 'store/constant';

/**
 * מסגרת טעינה לתוכן טאב — גובה יציב מול CLS, דומה לכרטיס/טפסים (מוק).
 * לשימוש ב־Suspense של ‎Loadable‎ במעברי מסלולים מקוננים (לא מסך מלא).
 */
const TabPanelSkeleton: React.FC = () => (
  <Box
    sx={{
      width: '100%',
      minHeight: customizationTabOutletMinHeight,
      boxSizing: 'border-box',
      px: { xs: 0.5, sm: 0 },
      py: 1,
    }}
    role="status"
    aria-busy="true"
  >
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Skeleton variant="rounded" height={36} sx={{ maxWidth: 280, borderRadius: 1 }} />
      <Skeleton variant="rounded" height={88} sx={{ borderRadius: 2 }} />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <Skeleton variant="rounded" height={148} sx={{ flex: 1, borderRadius: 2 }} />
        <Skeleton variant="rounded" height={148} sx={{ flex: 1, borderRadius: 2 }} />
      </Stack>
      <Skeleton variant="rounded" height={120} sx={{ borderRadius: 2 }} />
      <Skeleton variant="rounded" height={40} sx={{ borderRadius: 1 }} />
    </Stack>
  </Box>
);

export default TabPanelSkeleton;
